<template>
  <div>
    <p style="text-align: center">
      <span class="systemFont1">{{
        $t("schedulingAndPricing.schedulingAndPricing")
      }}</span>
    </p>
    <el-row style="top: 17px">
      <!-- 模糊查询 -->
      <div style="display: inline-block;">
        <el-form
          :model="queryForm"
          label-position="right"
          ref="queryForm"
          label-width="80px"
          class="systemFont1"
        >
          <!-- 课程名称 -->
          <div style="width:400px;display: inline-block; float:left;">
            <el-form-item :label="$t('p0331.courseTitle')">
              <el-input
                name="queryForm.courseName"
                type="text"
                v-model="queryForm.courseName"
                clearable
                :placeholder="$t('p0331.courseTitle')"
              ></el-input>
            </el-form-item>
          </div>
          <div style="width:40px;display:inline-block; float:left;">
            &nbsp;&nbsp;
          </div>
          <div
            style="width:70px;height:100%;display: inline-block; float:left;"
          >
            <img
              src="../../assets/query2.svg"
              width="36px"
              height="36px"
              style="cursor: pointer;"
              @click="init(true)"
            />
          </div>
        </el-form>
      </div>
      <el-col :span="22" :offset="1">
        <el-table
          :data="schedulingData"
          style="width: 100%; margin-bottom: 75px"
        >
          <el-table-column
            prop="field"
            :label="$t('courseOption.field')"
            align="left"
            min-width="52"
          >
          </el-table-column>
          <el-table-column
            prop="category"
            :label="$t('courseOption.category')"
            align="left"
            min-width="86"
          >
          </el-table-column>
          <el-table-column
            :formatter="valueFormat"
            :label="$t('courseOption.number')"
            align="left"
            min-width="48"
          >
          </el-table-column>
          <!-- 默认形式 -->
          <el-table-column
            prop="form"
            :label="$t('courseOption.defaultForm')"
            align="center"
            width="90"
          >
          </el-table-column>
          <el-table-column
            prop="courseName"
            :label="$t('courseOption.courseName')"
            align="left"
            min-width="210"
          >
          </el-table-column>
          <el-table-column
            prop="dateAndTime"
            :label="$t('schedulingAndPricing.recentSchedule')"
            align="left"
            min-width="76"
          >
          </el-table-column>
          <el-table-column
            :label="$t('common.operation')"
            align="center"
            min-width="50"
          >
            <template slot-scope="scope">
              <el-button @click="enter(scope.row)" type="text">{{
                $t("schedulingAndPricing.enter")
              }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-row style="text-align: right; margin: 20px">
          <el-col :span="24">
            <div class="block">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPagePr"
                :page-sizes="[10, 20, 50]"
                :page-size="pageSizePr"
                layout="total, sizes, prev, pager, next"
                :total="totalPr"
              >
              </el-pagination>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 查询条件
      queryForm: {
        courseName: ""
      },
      // 当前页
      currentPagePr: 1,
      // 每页件数
      pageSizePr: 10,
      totalPr: 0,
      // 排课数据
      schedulingData: []
    };
  },
  watch: {
    // 监听课程名称是否为空
    "queryForm.courseName"(newVal) {
      if (newVal == "") {
        this.queryForm.courseName = "";
        this.init(true);
      }
    }
  },
  methods: {
    // 每页数据条数设定
    handleSizeChange(val) {
      this.pageSizePr = val;
      this.currentPagePr = 1;
      //判断更改页码是否需要查询
      if (this.schedulingData == undefined || this.schedulingData.length <= 0) {
        return;
      }
      this.init(false);
      // console.log(`每页 ${val} 条`);
    },
    // 当前页显示
    handleCurrentChange(val) {
      this.currentPagePr = val;
      this.init(false);
      // console.log(`当前页: ${val}`);
    },
    // 初始化排课数据
    init(val) {
      if (val) {
        // 分页数据初始化
        this.currentPagePr = 1;
        this.totalPr = 0;
      }
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container")
      });
      let url = "/api/schedulingAndPricing/initScheduling";
      this.$http
        .post(url, {
          //课程名称模糊查询
          selectCourseName: this.queryForm.courseName,
          // 当前页
          currentSizePr: (this.currentPagePr - 1) * this.pageSizePr,
          // 页数
          pageSizePr: this.pageSizePr,
          // 总数
          totalPr: this.totalPr
        })
        .then(response => {
          if (response.data.code === 200) {
            // 判断有没有数据
            if (response.data.data == null) {
              this.schedulingData = [];
              loading.close();
            } else {
              this.schedulingData = response.data.data;
              // 总数取值
              this.totalPr = response.data.data[0].totalPr;
              loading.close();
            }
          } else {
            loading.close();
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          loading.close();
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },

    // 进入按钮
    enter(row) {
      let p0311 = JSON.stringify({
        field: row.fieldCode,
        category: row.categoryCode,
        courseNumber: row.courseNumber
      });
      sessionStorage.p0311 = p0311;
      // 跳转指定页面
      // this.$router.push({
      //   path: "/views/GreenJacketForum/P0312",
      // });
      this.$router.push({
        path: "/views/GreenJacketForum/P0312",
        query: {
          courseName: this.queryForm.courseName,
          currentPagePr: this.currentPagePr,
          totalPr: this.totalPr,
          pageSizePr: this.pageSizePr
        }
      });
    },

    // 课程编号拼接
    valueFormat(row) {
      return row.fieldCode + row.categoryCode + row.courseNumber;
    }
  },
  mounted() {
    if (this.$route.query.currentPagePr) {
      this.currentPagePr = Number(this.$route.query.currentPagePr);
    }
    if (this.$route.query.totalPr) {
      this.totalPr = Number(this.$route.query.totalPr);
    }
    if (this.$route.query.pageSizePr) {
      this.pageSizePr = Number(this.$route.query.pageSizePr);
    }
    if (this.$route.query.courseName) {
      this.queryForm.courseName = this.$route.query.courseName;
    }
    let path = this.$route.path; //先获取路由路径
    this.$router.replace(path); //再跳转路由路径，query参数没带过去，所以被清除了
    this.init(false);
  }
};
</script>

<style lang="scss" scoped>
>>> .el-table thead {
  font-family: "Arial Negreta", "Arial Normal", "Arial";
  color: #333333;
  font-size: 16px;
}

>>> .el-table__header {
  border-bottom: 3px solid rgb(170, 170, 170);
}

>>> .el-table__row {
  height: 42px;
}

>>> .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  border-bottom: 0.5px solid rgb(170, 170, 170);
}

>>> .el-table--border::after,
.el-table--group::after,
.el-table::before {
  background: none;
}
</style>



// WEBPACK FOOTER //
// src/views/GreenJacketForum/P0311.vue